module.exports = __webpack_public_path__ + "202408221624/img/animation_bainian.fdef3f74.png";